<template>
  <svg
    id="a"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 47.7 48.8"
  ><polygon
    points="37.72 25.96 40.82 39.69 28.04 33.79 27.84 33.91 24.84 35.69 15.93 40.98 16.13 39.35 16.13 39.35 17.59 27 12.52 22.55 12.52 22.55 7.02 17.71 13.27 16.47 14.11 16.3 20.82 14.97 26.39 2.04 33.27 14.32 47.28 15.62 37.72 25.96"
    fill="#891b1b"
    stroke-width="0"
  /><polygon
    points="36.78 28.07 40.01 42.4 26.67 36.25 26.47 36.37 23.33 38.23 14.04 43.75 14.24 42.05 14.24 42.04 15.77 29.16 10.48 24.51 10.48 24.51 4.74 19.46 11.26 18.17 12.14 17.99 19.15 16.6 24.96 3.11 32.13 15.93 46.76 17.28 36.78 28.07"
    fill="#eea320"
    stroke-width="0"
  /><polygon
    points="23.26 30.59 26.47 36.37 23.33 38.23 18.47 37.51 14.24 42.04 10.48 24.51 10.48 24.51 11.26 18.17 12.14 17.99 18.16 23.89 27.5 22.07 23.26 30.59"
    fill="#cc872a"
    stroke-width="0"
  /><polygon
    points="17.44 24.74 26.77 22.92 22.54 31.44 27.15 39.75 17.74 38.36 11.26 45.31 9.68 35.94 1.06 31.92 9.49 27.52 10.65 18.08 17.44 24.74"
    fill="#ffe000"
    stroke-width="0"
  /><path
    d="M4.37,32.42c1.85-.98,3.69-1.97,5.54-2.95.34-.18.04-.71-.31-.52l-5.54,2.95c-.34.18-.04.71.31.52h0Z"
    fill="#fff"
    stroke-width="0"
  /><path
    d="M33.87,18.19l6.26.39c.39.02.39-.58,0-.61l-6.26-.39c-.39-.02-.39.58,0,.61h0Z"
    fill="#fff"
    stroke-width="0"
  /><path
    d="M11.19,26.96c.21-1.72.43-3.44.64-5.15.02-.16-.15-.3-.3-.3-.18,0-.28.14-.3.3-.21,1.72-.43,3.44-.64,5.15-.02.16.15.3.3.3.18,0,.28-.14.3-.3h0Z"
    fill="#fff"
    stroke-width="0"
  /><path
    d="M22.61,12.86l2.06-4.77c.06-.15.04-.32-.11-.41-.13-.07-.35-.04-.41.11-.69,1.59-1.38,3.18-2.06,4.77-.06.15-.04.32.11.41.13.07.35.04.41-.11h0Z"
    fill="#fff"
    stroke-width="0"
  /><path
    d="M24.91,6.19c.39,0,.39-.61,0-.61s-.39.61,0,.61h0Z"
    fill="#fff"
    stroke-width="0"
  /><path
    d="M42.13,18.81c.16-.02.33-.02.49,0h-.08c.1,0,.19.02.28.05.15.04.34-.05.37-.21s-.05-.33-.21-.37c-.27-.08-.57-.11-.85-.07-.08.01-.15.03-.21.09-.05.05-.09.14-.09.21s.03.16.09.21c.05.05.14.1.21.09h0Z"
    fill="#fff"
    stroke-width="0"
  /><path
    d="M17.73,26.44c.4-.05.8-.12,1.2-.23.15-.04.26-.22.21-.37s-.21-.26-.37-.21c-.18.05-.36.09-.54.13-.09.02-.18.03-.28.05-.04,0-.08.01-.13.02-.01,0-.03,0-.04,0h.04s-.06,0-.09,0c-.08.01-.15.03-.21.09-.05.05-.09.14-.09.21s.03.16.09.21c.05.05.14.1.21.09h0Z"
    fill="#fff"
    stroke-width="0"
  /></svg>
</template>
